<template>
    <div>
        <bc-tooltip v-if="!noButton">
            <template slot="activator">
                <v-badge left class="pa-0" overlap color="primary-light">
                    <template slot="badge" v-if="printItems && printItems.length > 0">
                        <span>{{printItems.length}}</span>
                    </template>
                    <v-btn icon @mouseup.left="$emit('invoke-method');" class="ma-0">
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-badge>
            </template>
            {{ tooltip ? tooltip : $t('lang.print') }}
        </bc-tooltip>
        <bc-dialog :value="print_dialog" max-width="1024" content-class="print">
            <v-card>
                <v-card-title style="background-color: #ddd">
                    <span class="headline black--text">{{$t('lang.printDialog')}}</span>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="$emit('close-method')">{{$t('lang.printClose')}}</v-btn>
                    <v-btn v-if="user_is_dev" :disabled="!fileName" color='primary' class="white--text" :class="$bp.smallScreen ? 'mr-2': 'mr-3'" @mouseup.left="printReport(fileName)">{{$t('lang.print')}}</v-btn>
                </v-card-title>
                <app-section-loader :status="print_loader" style="margin-top:80px;" :style="frameDimensions"></app-section-loader> <!-- since buttons are not covered by loader, a local loader is okay -->
                <iframe v-if="fileName" id="print" :src="fileName+'?#zoom=100'" :style="frameDimensions"></iframe>
                <div v-else :style="frameDimensions"></div>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>

import printJS from 'print-js';

export default {
    // TODO: make fileName local variable
    props: ["fileName", "show", "noButton", "tooltip", "printItems"],
    data() {
        return {
            print_loader: false,
            print_dialog: false,
        };
    },
    methods: {
        printReport(url) {
            printJS({ printable: url, type: 'pdf' });
        },
        close(){
            this.print_dialog = false;
        },
        openDialog(){
            this.print_dialog = true;
        },
    },
    computed: {
        frameDimensions(){
            return {
                width: '100%',
                height: this.$bp.lgAndUp ? 'calc(100vh - 250px)' : '100vh'
            }
        }
    },
    watch: {
        fileName() {
            this.print_loader = false;
        },
        print_dialog(val){
            if(val && !this.fileName){
                this.print_loader = true;
            }else{
                this.print_loader = false;
            }
        }
    }
};

</script>